import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { ScreenOne } from "../../components/onboarding/screen-1";
import { StatePageContainer } from "../../components/ui-elements/pageUITransition";
import { ScreenTwo } from "../../components/onboarding/screen-2";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { OnboardApiData, OnboardData } from "../../interface/onboard";
import {
  getLgaById,
  getStates,
  SelectOption,
  State,
} from "../../utils/adhoc-request";
import {
  OnboardingMainModal,
  OnboardingSkipModal,
} from "../../components/onboarding/modal";
import { useMutation } from "@tanstack/react-query";
import { apiOnboarding } from "../../api/authentication";
import { useNotificationService } from "../../hooks/notification";
import { useDispatch } from "react-redux";
import { setVerification_status } from "../../store/contentSlice";
import useResponsive from "../../hooks/useResponsive";
import { LoadingSpinner } from "../../components/ui-elements/svg-icons";

const Onboarding: React.FC = () => {
  const isMedium = useResponsive("down", "md", "xl");
  const dispatch = useDispatch();
  const { showNotification } = useNotificationService();

  const [user_data, setUser_data] = useState<OnboardData>({
    name: "",
    dob: null,
    gender: "",
    state_id: "",
    local_government_id: "",
  });
  const [page_number, setPage_number] = useState<number>(1);
  const [states, setStates] = useState<SelectOption[]>([]);
  const [lga, setLga] = useState<SelectOption[]>([]);
  const [modal_state, setModal_state] = useState(false);
  const [modal_skip, setModal_skip] = useState(false);
  const fetch_states = async () => {
    try {
      const states_data = await getStates();
      setStates(states_data);
    } finally {
    }
  };

  const fetch_lga = async () => {
    try {
      const lgaData = await getLgaById(user_data?.state_id);
      setLga(lgaData);
    } finally {
    }
  };

  useEffect(() => {
    if (states.length === 0) {
      fetch_states();
    }
    if (user_data?.state_id != "") {
      fetch_lga();
    }
  }, [user_data?.state_id]);

  const handle_next = () => {
    setPage_number((prev) => prev + 1);
  };
  const handle_prev = () => {
    if (page_number === 1) {
      return;
    }
    setPage_number((prev) => prev - 1);
  };

  const handle_back = () => {
    if (page_number === 1) {
    } else {
      handle_prev();
    }
  };
  const handle_modal = () => {
    setModal_state(!modal_state);
  };
  const handle_modal_skip = () => {
    setModal_skip(!modal_skip);
  };

  const save_mutation = useMutation({
    mutationFn: (fields: OnboardApiData) => apiOnboarding(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(
            data?.details?.message || data.details[0] || "Unknown error",
            "error"
          );
          return;
        }
        return;
      }
      if (data.status === 201) {
        dispatch(setVerification_status("not-complete"));
        handle_modal_skip();
      }
    },
    onError: (error) => {
      showNotification("An error occurred", "error");
    },
  });

  const handle_skip = () => {
    if (page_number === 1) {
      handle_modal();
    } else if (page_number === 2) {
      save_mutation.mutate(user_data);
    }
  };

  return (
    <>
      <OnboardingMainModal open={modal_state} modal_handler={handle_modal} />
      <OnboardingSkipModal
        open={modal_skip}
        modal_handler={handle_modal_skip}
      />
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: "94%",
            mx: "auto",
            mt: 6,
          }}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            sx={{
              width: "100%",
            }}
          >
            {page_number === 1 && <Typography sx={{ mx: 2 }}></Typography>}
            {page_number != 1 && (
              <Button
                startIcon={<KeyboardArrowLeftIcon />}
                onClick={handle_back}
                sx={{
                  color: "#7991A4",
                }}
              >
                Back
              </Button>
            )}

            <img
              alt=""
              src="/assets/icons/logo-green.svg"
              width={100}
              height={35}
            />
            <Button
              endIcon={<KeyboardArrowRightIcon />}
              onClick={handle_skip}
              sx={{
                color: "#7991A4",
              }}
            >
              {page_number === 2
                ? isMedium
                  ? "Skip"
                  : "Save and skip"
                : "Skip"}
            </Button>
          </Stack>
          <Stack sx={{ my: 2 }}>
            <Typography
              variant="body1"
              sx={{
                color: "#92A5B5",
                textAlign: "center",
                letterSpacing: "3px",
                fontWeight: 500,
              }}
            >
              {page_number}/2
            </Typography>
          </Stack>
          <>
            {/* <AnimatePresence mode="wait" initial={false}> */}
            {page_number === 1 && (
              <StatePageContainer id="page1">
                <ScreenOne
                  next={handle_next}
                  states={states}
                  lga={lga}
                  user_data={user_data}
                  setUser_data={setUser_data}
                />
              </StatePageContainer>
            )}
            {page_number === 2 && (
              <StatePageContainer id="page2">
                <ScreenTwo
                  prev={handle_prev}
                  user_data={user_data}
                  setUser_data={setUser_data}
                />
              </StatePageContainer>
            )}

            {/* </AnimatePresence> */}
          </>
          {/* loading spinner for save mutation */}
          {save_mutation.isPending && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <LoadingSpinner />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Onboarding;
